/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-05-09 15:13:27
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2024-04-01 09:57:41
 * @FilePath     : \gray-fabric-defect-management-frontend\src\router\index.ts
 * @Description  : 这是描述
 */

import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

import BaseLayout from "../layout/baseLayout/index.vue";

import Account from "../page/behind/account/index.vue";

import News from "../page/behind/news/index.vue";
import Alias from "../page/behind/alias/index.vue";
import Settings from '../page/behind/account/settings/index.vue'
import SystemMange from "../page/behind/admin/systemMange/index.vue";
import UserMange from "../page/behind/admin/userMange/index.vue";
import RoleMange from "../page/behind/admin/roleMange/index.vue";
import MenuMange from "../page/behind/admin/menuMange/index.vue";
import LogMange from "../page/behind/admin/logMange/index.vue";
import LogicType from "../page/behind/logic/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "登录",
    component: () => import("@/page/login/index.vue"),
  },
  {
    path: "/test",
    name: "测试",
    component: () => import("@/page/test/index.vue"),
  },
  {
    path: "/",
    name: "baseLayout",
    component: BaseLayout,
    redirect: "/manage/home",
    children: [
      {
        path: "/manage/home",
        component: () => import("@/page/behind/home/index.vue"),
        name: 'router.home',//"主页",
        meta: {
          icon: "home-outlined",
        },
      },
      {
        path: "/manage/defectRecord",
        component: () => import("@/page/behind/defectRecord/index.vue"),
        name: 'router.defectRecord',// "缺陷记录",
        meta: {
          icon: "reconciliation-Outlined",
        },
      },
      {
        path: "/machine",
        component: () => import("@/page/behind/machine/index.vue"),
        name: 'router.machine',// "机器管理",
        meta: {
          icon: "cluster-outlined",
        },
      },
      // {
      //   path: "/manage/resources",
      //   name: "资源管理",
      //   meta: {
      //     icon: "user-outlined",
      //   },
      //   children: [
      //     {
      //       path: "/manage/resources/project",
      //       component: () => import('@/page/behind/project/index.vue'),
      //       name: "项目",
      //     },
      //     {
      //       path: "/manage/resources/equipment",
      //       component: () => import('@/page/behind/equipment/index.vue'),
      //       name: "设备",
      //     },
      //   ],
      // },
      // {
      //   path: "/manage/operation",
      //   name: "设备管理",
      //   meta: {
      //     icon: "user-outlined",
      //   },
      //   children: [
      //     {
      //       path: "/manage/operation/single",
      //       component: () => import('@/page/behind/single/index.vue'),
      //       name: "单点维护",
      //     },
      //     {
      //       path: "/manage/operation/batch",
      //       component: () => import('@/page/behind/batch/index.vue'),
      //       name: "批量维护",
      //     },
      //     {
      //       path: "/manage/operation/version",
      //       component: () => import('@/page/behind/version/index.vue'),
      //       name: "版本管理",
      //     },
      //   ],
      // },
      {
        path: "/manage/account",
        name: 'router.user',// "个人中心",
        meta: {
          icon: "user-outlined",
        },
        children: [
          {
            path: "/manage/account/settings",
            component: Settings,
            name: 'router.userSetting',// "个人设置",
          },
          {
            path: "/manage/account/export-manage",
            component: () => import('@/page/behind/account/exportManage/index.vue'),
            name: 'router.export',//"导出管理",
          },
          {
            path: "/manage/account/clean-data",
            component: () => import('@/page/behind/account/cleanData/index.vue'),
            name: 'router.cleanData',//"清理数据"
          }
        ],
      },
      // {
      //   path: "/manage/admin",
      //   name: "系统配置",
      //   meta: {
      //     icon: "setting-outlined",
      //   },
      //   children: [
      //     {
      //       path: "/manage/admin/userMange",
      //       component: UserMange,
      //       name: "用户管理",
      //     },
      //     {
      //       path: "/manage/admin/roleMange",
      //       component: RoleMange,
      //       name: "角色管理",
      //     },
      //     {
      //       path: "/manage/admin/menuMange",
      //       component: MenuMange,
      //       name: "菜单管理",
      //     },
      //     {
      //       path: "/manage/admin/systemMange",
      //       component: SystemMange,
      //       name: "系统配置",
      //     },
      //     {
      //       path: "/manage/admin/logMange",
      //       component: LogMange,
      //       name: "日志管理",
      //     },
      //   ],
      // },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
export default router;
